import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Customer, CustomerService } from '../../services/customer';
import { FilteredSalesOrder, SalesOrderService } from '../../services/sales-order';
import { CustomerSearchComponent } from '../../components/customer-search-component/customer-search-component';
import { MatButtonModule } from '@angular/material/button';
import { MessageDialogService } from '../../services/message-dialog';
import { Router } from '@angular/router';
import { SalesOrderSelectionService } from '../../services/sales-order-selection';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { SelectedProduct } from '../../services/products';
import { CartComponent } from '../../components/cart-component/cart-component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-sales-order-report',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CustomerSearchComponent,
    MatButtonModule,
    MatCardModule,
    CartComponent
  ],
  templateUrl: './sales-order-report-component.html',
  styleUrls: ['./sales-order-report-component.scss']
})
export class SalesOrderReportComponent {
  startDate: string = '';
  endDate: string = '';
  selectedCustomer: Customer | null = null;
  selectedCustomerFromList: Customer | null = null;
  orders: FilteredSalesOrder[] = [];
  totalAmount: number = 0;
  page: number = 1;
  pageSize: number = 10;
  totalPages: number = 1;
  selectedProducts: SelectedProduct[] = [];
  showCart: boolean = false;

  constructor(
    private salesOrderService: SalesOrderService,
    private messageDialogService: MessageDialogService,
    private customerService: CustomerService
  ) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    this.startDate = today.toISOString().split('T')[0];
    this.endDate = tomorrow.toISOString().split('T')[0];
  }

  fetchOrders(): void {
    if (!this.startDate || !this.endDate) {
      this.messageDialogService.warning('Please select start and end dates.');
      return;
    }

    const payload = {
      startDate: this.startDate,
      endDate: this.endDate,
      customerId: this.selectedCustomer?.id,
      page: this.page,
      limit: this.pageSize,
      includeTotals: true
    };

    this.salesOrderService.filterOrders(payload).subscribe((res) => {
      if (res.status === 'success') {
        this.orders = res.orders;
        this.totalAmount = res.grandTotal ?? 0;
        this.totalPages = res.pagination?.pages ?? 1;
      } else {
        this.orders = [];
        this.totalAmount = 0;
        this.totalPages = 1;
      }
    });
  }

  nextPage(): void {
    if (this.page < this.totalPages) {
      this.page++;
      this.fetchOrders();
    }
  }

  prevPage(): void {
    if (this.page > 1) {
      this.page--;
      this.fetchOrders();
    }
  }

  handleCustomerSelection(customer: Customer | null): void {
    this.selectedCustomer = customer;
    console.log('Selected Customer:', customer);
  }

  async viewOrderDetails(order: FilteredSalesOrder) {
    try {
      // Fetch the order details using the order ID from the selection service
      const response = await firstValueFrom(this.salesOrderService.getSalesOrderById(order.order_id));
      if (response.status !== 'success') {
        this.messageDialogService.error(response.message || 'Failed to fetch order');
        return;
      }

      const orderDetails = response.order;
      if (!orderDetails) return;

      // Set the selected products
      this.selectedProducts = orderDetails.lines.map(line => ({
        productId: line.product_id,
        quantity: line.quantity,
        price: line.price_unit
      }));

      // Fetch the customer details
      const customers = await firstValueFrom(this.customerService.get());
      this.selectedCustomerFromList = customers.find(c => c.id === orderDetails.customerId) ?? null;
      this.showCart = true;

    } catch (err) {
      console.error('Failed to load sales order', err);
      this.messageDialogService.error('Failed to load sales order');
    }

    // Set the selected order in the SalesOrderSelectionService
    //this.salesOrderSelectionService.set(order);
    //// Navigate to the view-sales-order page
    //this.router.navigate(['/view-sales-order']);
  }
}
